//these values are set in the pipeline
export const environment = {
  production: true,
  occ_api_url: 'https://shopapi.foerch.com',
  mc_api_url: 'https://serviceapi.foerch.com/prodref',
  socket_api_url: 'https://serviceapi.foerch.com//notification-hub',
  client_id: 'spartacus',
  client_secret: 'Zie4og95FqRPAXdg',
};
